<div class="module-wrapper content-wrapper" *ngIf="roleSer.accessData && (roleSer.accessData.viewAllowed || roleSer.accessData.insertAllowed)">
  <mat-card>
    <mat-card-content>
      <div class="head-container">
        <h1>{{'examinee.heading' | translate}}</h1>
        <!-- <div (mouseover)="onTraningIcon(videoAssetGroups.ExamineeManagement)">
          <img class="trainingIcon" src="../../../assets/favicon/video.png">
        </div>
        <div class="popupHover">
          <ng-container *ngIf="isHidden">
            <div class="hideshow">
              <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
            </div>
          </ng-container>
        </div> -->
      </div>
      <div class="itemBtn">
        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button color="warn" class="btn-warn" aria-label="Add New Item" (click)="openNewExamineeDialog()"
              [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true)"> + {{'examinee.btnNew' | translate}}</button>
            <button mat-flat-button class="btn-brown" (click)='addMultileExaminee()'
              [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true)"> <span>+ {{'examinee.btnMultiple' | translate}}</span></button>
          </div>
        </div>
      </div>


      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper invalid">
            <input type="text" [(ngModel)]='firstName' placeholder="{{'examinee.labelFname' | translate}}"
              class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Name">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" [(ngModel)]='lastName' placeholder="{{'examinee.labelLname' | translate}}"
              class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Name">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" [(ngModel)]='emailId' placeholder="{{'examinee.labelMail' | translate}}"
              class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Email" >
          </div>
          <div class="input-wrapper">
            <select aria-placeholder="Status" [(ngModel)]='status' class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="" ng-reflect-value="" selected>{{'examinee.status.option1' | translate}}</option>
              <option [value]="Status.id == 1 ? 'true' : 'false'" ng-reflect-value="none" *ngFor="let Status of statusList">{{Status.title}}</option>
            </select>
          </div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-primary" aria-label="Search" (click)='examineesFilter()'>{{'examinee.btnSearch' | translate}}</button>
            <button mat-flat-button color="" class="btn-flat" aria-label="Reset" (click)='resetFilter()'>{{'examinee.btnReset' | translate}}</button>
          </div>
        </div>
      </div>
      <div *ngIf="isNoExaminee" class="data-not-found-container table-container">
        <span>{{'examinee.noExamineeMsg' | translate}}</span>
      </div>
      <div *ngIf="!isNoExaminee && !noDataFound">
        <div class="table-container">
          <div *ngIf="isNoExaminee" class="data-not-found-container table-container">
            <span>No Examinees for this client</span>
          </div>
          <table *ngIf="!isNoExaminee" mat-table [dataSource]="examineesData" class="mat-elevation-z8">

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'examinee.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                {{row?.firstName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'examinee.column2' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                {{row.lastName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="emailId">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'examinee.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="row.emailId.length > 30 then sliceEmail else noSliceEmail"></ng-container>
                <ng-template #sliceEmail>
              <td matTooltip="{{row?.emailId}}" matTooltipPosition="above" innerHtml="{{row?.emailId | slice:0:15}} ..." class="itemrow">...
              </td>
              </ng-template>
              <ng-template #noSliceEmail>
                <td class="itemrow">{{row.emailId}}</td>
              </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'examinee.column4' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <!--  <i *ngIf="row?.active === true" class="fa fas fa-circle publish"
                                matTooltip="Active"
                                matTooltipPosition="above">
                            </i>-->
                <span *ngIf="row?.active === true" class="fa fas fa-circle publish"
                matTooltip="{{'examinee.statusTooltip.active' | translate}}" matTooltipPosition="above">
                </span>
                <span *ngIf="row?.active === false" class="glyphicon glyphicon-adjust unpublish" matTooltip="{{'examinee.statusTooltip.inactive' | translate}}" matTooltipPosition="above">
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="updated">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'examinee.column5' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="text-bold"> {{row.modifiedBy}} </div>
                <div> {{ row.modifiedDateTime | dateAgo }} </div>

              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> Action </th>
                        <td mat-cell *matCellDef="let row"> -->
            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"> -->
            <!-- <mat-icon>more_vert</mat-icon> -->
            <!-- </button> -->
            <!-- <mat-menu #menu="matMenu">
                            <button mat-menu-item >
                              <mat-icon>edit</mat-icon>
                              <span>Edit</span>
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container> -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr class="(roleSer.accessData?!roleSer.accessData.updateAllowed :true)  ? pointer111 : pointer" mat-row
              *matRowDef="let row; columns: displayedColumns;"
              (click)="(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? '' : openEditExamineeDialog(row.examineeuuid)"></tr>
          </table>
        </div>
        <div class="examinee-paginator" *ngIf="examineesDataCount.length > 0">
          <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
      <div class="data-not-found-container" *ngIf='noDataFound'>
        <p>{{'examinee.errorMsg' | translate}}</p>
      </div>
    </mat-card-content>
  </mat-card>
</div>









<!--
<div class="users-container main-content-wrapper">
    <div class="content-wrapper">
        <div class="filter-section">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-8">
                        <div class="input-fields-wrapper">
                            <div class="input-wrapper">
                                <input type="text" class="form-control" [(ngModel)]='firstName' placeholder="First name">
                                <input type="text" class="form-control" [(ngModel)]='lastName' placeholder="Last name">
                                <input type="text" class="form-control" [(ngModel)]='emailId' placeholder="Email">
                                <select aria-placeholder="Status" class="form-control" [(ngModel)]='status'>
                                    <option value="">Status</option>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>
                            </div>
                            <div class="btn-wrapper">
                                <button (click)='examineesFilter()' class="btn-bg-color" mat-raised-button>
                                    <span>Search</span>
                                </button>
                                <button (click)='resetFilter()' class="btn-green-text"  mat-raised-button>
                                    <span>Reset</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="btn-wrapper">
                            <button (click)='addMultileExaminee()' class="btn-brown" mat-flat-button>
                                <span>+ Multiple Examinees</span>
                            </button>
                            <button (click)='createNewExaminee()' class="btn-orange" mat-flat-button>
                                <span>+ New Examinee</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container-fluid">
            <div class="row"> -->
<!-- <div class="container-fluid">
            <div *ngIf="isNoExaminee" class="data-not-found-container table-container">
                      <span>No Examinees for this client</span>
            </div>
            <div *ngIf="!isNoExaminee" class="row">
                <div class="col-md-12">                     -->
<!-- <div class="success">{{messages}}</div> -->
<!-- <div class="table-container">
                        <table mat-table [dataSource]="examineesData" matSort class="mat-elevation-z8">
                            <ng-container matColumnDef="firstName">
                                <th mat-header-cell *matHeaderCellDef >First name</th>
                                <td mat-cell *matCellDef="let row">
                                    <span (click)='navigateToExamineeDetails(row.examineeuuid)'>{{row?.firstName}}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="lastName" >
                                <th mat-header-cell *matHeaderCellDef >Last name </th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToExamineeDetails(row.examineeuuid)'>
                                    {{row.lastName}}</td>
                            </ng-container>
                            <ng-container matColumnDef="emailId">
                                <th mat-header-cell *matHeaderCellDef >Email </th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToExamineeDetails(row.examineeuuid)'>
                                    {{row.emailId}}</td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToExamineeDetails(row.examineeuuid)'>
                                    <i *ngIf="row?.active === true" class="fa fas fa-circle publish"
                                    matTooltip="Active"
                                    matTooltipPosition="right"></i>
                                    <span *ngIf="row?.active === false" class="glyphicon glyphicon-adjust unpublish"
                                    matTooltip="Inactive"
                                    matTooltipPosition="right"></span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updated">
                                <th mat-header-cell *matHeaderCellDef mat-sort->Updated</th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToExamineeDetails(row.examineeuuid)'>
                                    <span class="modified-user">{{row.modifiedBy}}</span> <br>
                                     {{row.modifiedDateTime | dateAgo}}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <div class="data-not-found-container" *ngIf='noDataFound'>
                            <p>Data not found</p>
                        </div>

                    </div>
                    <div class="examinee-paginator">
                        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>  -->
